import { Component, OnInit } from '@angular/core';
import { FeedService } from '../../service/feed-service.service';
import { FeedItems } from '../../model/feed-items'
import { from, Observable } from 'rxjs';

@Component({
  selector: 'app-bulletin',
  templateUrl: './bulletin.component.html',
  styleUrls: ['./bulletin.component.css']
})
export class BulletinComponent implements OnInit {

  honorFeedUrl: string = 'https%3A%2F%2Fgroups.google.com%2Fforum%2Ffeed%2Fccps-honorroll%2Ftopics%2Frss.xml%3Fnum%3D5&api_key=hmg1be5dlazmlii5j2nbsrfh9d7ykxd7oe7jrvlf&order_by=pubDate';
  honorFeedsObservable: any;
  honorFeeds: any;
  honorItems: Observable<FeedItems>;
  
  bulletinFeedUrl: string= 'https%3A%2F%2Fgroups.google.com%2Fforum%2Ffeed%2Fccps-bulletin%2Ftopics%2Frss.xml%3Fnum%3D5';
  bulletinFeedsObservable: any;
  bulletinFeeds: any;
  bulletinItems: Observable<FeedItems>;

  campFeedUrl: string= 'https%3A%2F%2Fgroups.google.com%2Fforum%2Ffeed%2Fccps-camp%2Ftopics%2Frss.xml%3Fnum%3D15';
  campFeedsObservable: any;
  campFeeds: any;
  campItems: Observable<FeedItems>;


  constructor(public feedService: FeedService) { 
      }

  ngOnInit() {
    this.refreshFeed();
    
  }
 
  refreshFeed(){
    this.honorFeedsObservable =  this.feedService.getFeedContent(this.honorFeedUrl);
    this.bulletinFeedsObservable = this.feedService.getFeedContent(this.bulletinFeedUrl);
    this.campFeedsObservable = this.feedService.getFeedContent(this.campFeedUrl);

    this.honorFeedsObservable.subscribe(res => {
      this.honorFeeds = res;
      this.honorItems = this.honorFeeds.items;
      
    }); 
    this.bulletinFeedsObservable.subscribe(res => {
      this.bulletinFeeds = res;
      this.bulletinItems = this.bulletinFeeds.items;
    }); 
    this.campFeedsObservable.subscribe(res => {
      this.campFeeds = res;
      //console.log(this.campFeeds);
      this.campItems = this.campFeeds.items.slice(0,5);
      //console.log(this.campItems);
    }); 
  }
}
